module.exports = __webpack_public_path__ + "img/fiskeri_akvakultur_paavirkning_biologiske.28435582.jpg";